export const TIME_FULL = 'timeFull';
export const HOURS_MINUTES = 'hoursMinutes';